import { createFileRoute } from '@tanstack/react-router'
import { Inbox } from 'pages/inbox/Inbox'

export const Route = createFileRoute('/inbox/')({
  component: Inbox,
  staticData: {
    title: 'Inbox',
  },
})
